import { render } from "./PersonaManagement.vue?vue&type=template&id=27c207a9&scoped=true"
import script from "./PersonaManagement.vue?vue&type=script&lang=js"
export * from "./PersonaManagement.vue?vue&type=script&lang=js"

import "./PersonaManagement.vue?vue&type=style&index=0&id=27c207a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c207a9"]])

export default __exports__